import type { RouteRecordRaw } from 'vue-router'
const DefaultLayout = () => import('@/layouts/DefaultLayout.vue')

export const cesispeRoutes: RouteRecordRaw[] = [
  {
    path: '/cesispe',
    component: DefaultLayout,
    meta: {
      requireAuth: true,
      module: 'cesispeTools'
    },
    children: [
      {
        path: '',
        redirect: { name: 'cesispe.transactions' }
      },
      {
        path: '',
        component: () =>
          import('@/views/toolsOperations/toolOperationsHomeView.vue'),
        children: [
          {
            path: 'transactions',
            name: 'cesispe.transactions',
            component: () =>
              import('@/modules/cesispe/ui/view/transactionsExecuted.vue')
          },
          {
            path: 'information',
            name: 'cesispe.information',
            component: () =>
              import('@/modules/cesispe/ui/view/informationCurrent.vue')
          }
          
        ]
      }
    ]
  }
]
